/**
 * @generated SignedSource<<08d072de212e45c5bab1364ff72fa589>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserCellInternal$data = {
  readonly fieldId: string;
  readonly type: string;
  readonly user: {
    readonly accountId: string;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"UserCellInternal179BadPattern">;
  readonly " $fragmentType": "UserCellInternal";
};
export type UserCellInternal$key = {
  readonly " $data"?: UserCellInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCellInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "UserCellInternal",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "UserCellInternal179BadPattern"
    }
  ],
  "type": "JiraSingleSelectUserPickerField"
};

(node as any).hash = "0a2e78e5acde83fed9f02d96eed33af4";

export default node;
